// Number of events to display in the peek view.
export const NUMBER_EVENTS_TO_DISPLAY = 1;
